export default "__VITE_ASSET__e60f81cc__"